@let method = selectedUsage();
@let $packName = packName();

<div class="app-row gapped tight">
  @for ($method of methods; track $method) {
    <app-button
      [type]="method === $method ? 'primary' : 'secondary'"
      [icon]="$method.icon"
      [label]="$method.label"
      (clicked)="selectedUsage.set($method)"
    />
  }
</div>

<div class="scroll-container app-fill">
  <div class="app-column gapped left-items">
    @switch (method.method) {
      @case ('cli') {
        <h3>Install the CLI</h3>
        <pre class="code">npm install -g &#64;sysprompthub/cli</pre>

        <h3>Configure your project</h3>
        <ol>
          <li>Open your project directory in a terminal.</li>
          <li>Run <code>sysprompthub init</code></li>
          <li>If you are asked for your API Key, <a [routerLink]="['/api-keys']" target="_blank">find it here</a>.</li>
          <li>When asked for the prompt pack enter <code>{{ $packName }}</code></li>
          <li>Select the version and AI assistants you want to use.</li>
        </ol>

        <h3>More Information</h3>
        <p>
          <a href="https://www.npmjs.com/package/@sysprompthub/cli" target="_blank" rel="noopener">
            View CLI documentation on npm
          </a>
        </p>
      }
      @case ('vscode') {
        <h3>Install the extension</h3>
        <p>
          <app-button type="download" label="Install" (clicked)="vscode.openExtensionPage()"/>
        </p>

        <h3>Configure your project</h3>
        <ol>
          <li>Open a project in VS Code.</li>
          <li>If you are asked for your API Key, <a [routerLink]="['/api-keys']" target="_blank">find it here</a>.</li>
          <li>The extension will display a message asking if you want to configure a prompt.</li>
          <li>Click the <strong>"Configure Prompt"</strong> button.</li>
          <li>Enter <code>{{ $packName }}</code>.</li>
          <li>Select the version and AI assistants you want to use.</li>
        </ol>
      }
      @case ('manual') {
        @let download = downloadBlob | async;
        <h3>Manual Installation</h3>
        <p>Copy or download the pack contents and add it to your project manually.</p>
        <p class="app-row-auto gapped">
          @if (download) {
            <app-button type="copy" buttonStyle="primary" (clicked)="copyToClipboard(download)"/>

            <a class="btn" [href]="download.url" [download]="downloadFilename()">
              <icon type="download"/>
              <span>Download</span>
            </a>
          } @else {
            <span>Please wait...</span>
          }
        </p>

        <h3>Prompt Location</h3>
        After downloading, move the file or copy the contents into the appropriate location in your project.

        <h4>GitHub Copilot</h4>
        <pre class="code">.github/copilot-instructions.md</pre>

        <h4>Claude</h4>
        <pre class="code">.claude/system.md</pre>

        <h4>Other Assistants</h4>
        Please consult the documentation of your chosen assistant.
      }
    }
  </div>
</div>
